import { Route } from "vue-router";
import { RegexMatch } from "@/data/enums/router";
import CProdsListing from "@/components/app/global/contractProducts/cProdsListing.vue";
import ClientProductsView from "@/views/client/products/index.vue";
import {
  ClientCategoryProductsTabigation,
  ClientOneTimePurchasesTabigation,
  ClientProductsTabigation,
  ClientSubscriptionsTabigation
} from "@/router/client/products/menu";

import {
  IsActiveParam,
  IsInactiveParam,
  IsSubscriptionParam,
  IsOneTimePurchaseParam,
  IsCategoryParam,
  ProductNameFilter,
  ProductCategoryNameFilter,
  StatusCodesFilter,
  ActiveStatusCodesFilter,
  CancelledStatusCodesFilter,
  PriceFilter,
  DatePurchasedFilter,
  NextDueDateFilter
} from "@/data/filters/contractProducts";
import {
  DatePurchasedSorter,
  DefaultCProdSorters,
  StatusSorter
} from "@/data/sorters/contractProducts";
import { $bus } from "@/boot/event-bus";

export default [
  {
    path: "products",
    name: "clientProducts",
    redirect: { name: "client__activeProducts" },
    component: {
      name: "ClientProductsWrapper",
      template: "<router-view />"
    },
    meta: {},
    children: [
      /** ALL products */
      {
        path: "all",
        name: "client__products",
        redirect: { name: "client__activeProducts" },
        component: ClientProductsView,
        props: {
          routes: ClientProductsTabigation
        },
        meta: {
          title: "_.products_and_services"
        },
        children: [
          {
            path: "",
            name: "client__allProducts",
            component: CProdsListing,
            props: {
              availableSorters: DefaultCProdSorters,
              availableFilters: () => [
                DatePurchasedFilter(),
                NextDueDateFilter(),
                PriceFilter(),
                ProductNameFilter(),
                ProductCategoryNameFilter(),
                StatusCodesFilter()
              ]
            }
          },
          {
            path: "active",
            name: "client__activeProducts",
            component: CProdsListing,
            props: {
              availableSorters: DefaultCProdSorters,
              availableFilters: () => [
                DatePurchasedFilter(),
                NextDueDateFilter(),
                PriceFilter(),
                ProductNameFilter(),
                ProductCategoryNameFilter(),
                ActiveStatusCodesFilter()
              ],
              routeFilters: () => ({
                ...IsActiveParam()
              })
            }
          },
          {
            path: "cancelled",
            name: "client__cancelledProducts",
            component: CProdsListing,
            props: {
              availableSorters: () => [DatePurchasedSorter(), StatusSorter()],
              availableFilters: () => [
                DatePurchasedFilter(),
                PriceFilter(),
                ProductNameFilter(),
                ProductCategoryNameFilter(),
                CancelledStatusCodesFilter()
              ],
              routeFilters: () => ({
                ...IsInactiveParam()
              })
            }
          }
        ]
      },
      /** SUBSCRIPTION products */
      {
        path: "subscriptions",
        name: "client__subscriptions",
        redirect: { name: "client__activeSubscriptions" },
        component: ClientProductsView,
        props: {
          routes: ClientSubscriptionsTabigation
        },
        meta: {
          title: "_.subscriptions"
        },
        children: [
          {
            path: "",
            name: "client__allSubscriptions",
            component: CProdsListing,
            props: {
              availableSorters: DefaultCProdSorters,
              availableFilters: () => [
                DatePurchasedFilter(),
                NextDueDateFilter(),
                PriceFilter(),
                ProductNameFilter(),
                ProductCategoryNameFilter(),
                StatusCodesFilter()
              ],
              routeFilters: () => ({
                ...IsSubscriptionParam()
              })
            }
          },
          {
            path: "active",
            name: "client__activeSubscriptions",
            component: CProdsListing,
            props: {
              availableSorters: DefaultCProdSorters,
              availableFilters: () => [
                DatePurchasedFilter(),
                NextDueDateFilter(),
                PriceFilter(),
                ProductNameFilter(),
                ProductCategoryNameFilter(),
                ActiveStatusCodesFilter()
              ],
              routeFilters: () => ({
                ...IsSubscriptionParam(),
                ...IsActiveParam()
              })
            }
          },
          {
            path: "cancelled",
            name: "client__cancelledSubscriptions",
            component: CProdsListing,
            props: {
              availableSorters: () => [DatePurchasedSorter(), StatusSorter()],
              availableFilters: () => [
                DatePurchasedFilter(),
                PriceFilter(),
                ProductNameFilter(),
                ProductCategoryNameFilter(),
                CancelledStatusCodesFilter()
              ],
              routeFilters: () => ({
                ...IsSubscriptionParam(),
                ...IsInactiveParam()
              })
            }
          }
        ]
      },
      /** ONE-TIME PURCHASE products */
      {
        path: "one-time-purchases",
        name: "client__oneTimePurchases",
        redirect: { name: "client__activeOneTimePurchases" },
        component: ClientProductsView,
        props: {
          routes: ClientOneTimePurchasesTabigation
        },
        meta: {
          title: "_.one_time_purchases"
        },
        children: [
          {
            path: "",
            name: "client__allOneTimePurchases",
            component: CProdsListing,
            props: {
              availableSorters: () => [DatePurchasedSorter(), StatusSorter()],
              availableFilters: () => [
                DatePurchasedFilter(),
                PriceFilter(),
                ProductNameFilter(),
                ProductCategoryNameFilter(),
                StatusCodesFilter()
              ],
              routeFilters: () => ({
                ...IsOneTimePurchaseParam()
              })
            }
          },
          {
            path: "active",
            name: "client__activeOneTimePurchases",
            component: CProdsListing,
            props: {
              availableSorters: () => [DatePurchasedSorter(), StatusSorter()],
              availableFilters: () => [
                DatePurchasedFilter(),
                PriceFilter(),
                ProductNameFilter(),
                ProductCategoryNameFilter(),
                ActiveStatusCodesFilter()
              ],
              routeFilters: () => ({
                ...IsOneTimePurchaseParam(),
                ...IsActiveParam()
              })
            }
          },
          {
            path: "cancelled",
            name: "client__cancelledOneTimePurchases",
            component: CProdsListing,
            props: {
              availableSorters: () => [DatePurchasedSorter(), StatusSorter()],
              availableFilters: () => [
                DatePurchasedFilter(),
                PriceFilter(),
                ProductNameFilter(),
                ProductCategoryNameFilter(),
                CancelledStatusCodesFilter()
              ],
              routeFilters: () => ({
                ...IsOneTimePurchaseParam(),
                ...IsInactiveParam()
              })
            }
          }
        ]
      },
      /** CATEGORY products */
      {
        path: `category/:categoryId(${RegexMatch.UUID})`,
        name: "client__categoryProducts",
        redirect: { name: "client__activeCategoryProducts" },
        component: ClientProductsView,
        props: {
          routes: ClientCategoryProductsTabigation
        },
        meta: {
          title: "_.products_by_category"
        },
        children: [
          {
            path: "",
            name: "client__allCategoryProducts",
            component: CProdsListing,
            props: {
              availableSorters: DefaultCProdSorters,
              availableFilters: () => [
                DatePurchasedFilter(),
                NextDueDateFilter(),
                PriceFilter(),
                ProductNameFilter(),
                StatusCodesFilter()
              ],
              routeFilters: vm => ({
                ...IsCategoryParam(vm)
              })
            }
          },
          {
            path: "active",
            name: "client__activeCategoryProducts",
            component: CProdsListing,
            props: {
              availableSorters: DefaultCProdSorters,
              availableFilters: () => [
                DatePurchasedFilter(),
                NextDueDateFilter(),
                PriceFilter(),
                ProductNameFilter(),
                ActiveStatusCodesFilter()
              ],
              routeFilters: vm => ({
                ...IsCategoryParam(vm),
                ...IsActiveParam()
              })
            }
          },
          {
            path: "cancelled",
            name: "client__cancelledCategoryProducts",
            component: CProdsListing,
            props: {
              availableSorters: () => [DatePurchasedSorter(), StatusSorter()],
              availableFilters: () => [
                DatePurchasedFilter(),
                PriceFilter(),
                ProductNameFilter(),
                CancelledStatusCodesFilter()
              ],
              routeFilters: vm => ({
                ...IsCategoryParam(vm),
                ...IsInactiveParam()
              })
            }
          }
        ]
      }
    ]
  },
  {
    path: `products/:contractId(${RegexMatch.UUID})/:productId(${RegexMatch.UUID})`,
    component: {
      name: "ClientContractProductWrapper",
      template: "<router-view :key='$route.params.productId.toString()' />"
    },
    children: [
      {
        path: "",
        name: "clientCProd",
        redirect: "overview",
        component: () => import("@/views/client/products/product/index.vue"),
        props: (route: Route) => ({
          contractId: route.params.contractId,
          productId: route.params.productId,
          routes: require("./menu").cProdTabigation
        }),
        meta: {
          title: "_.product_and_service"
        },
        children: [
          {
            path: "overview",
            name: "clientCProdOverview",
            component: () =>
              import(
                "@/components/app/global/contractProducts/cProdOverview.vue"
              ),
            beforeEnter: (to, from, next) => {
              $bus.$emit("cProdProvider::reloadData");
              next();
            }
          },
          {
            path: "invoices",
            name: "clientCProdInvoices",
            component: () =>
              import(
                "@/components/app/global/client/contractProducts/contractProductInvoices.vue"
              )
          },
          {
            path: "credit-notes",
            name: "clientCProdCreditNotes",
            component: () =>
              import(
                "@/components/app/global/client/contractProducts/contractProductCreditNotes.vue"
              )
          },
          {
            path: "settings",
            name: "clientCProdSettings",
            component: () =>
              import(
                "@/components/app/global/client/contractProducts/contractProductSettings.vue"
              )
          },
          {
            path: "manage",
            name: "clientCProdProvisioning",
            component: () =>
              import("@/views/client/products/product/manage/index.vue")
          },
          {
            path: "delegates",
            name: "clientCProdDelegates",
            component: () =>
              import(
                "@/components/app/global/client/contractProducts/contractProductDelegates.vue"
              ),
            meta: {
              title: "_.delegates"
            }
          }
        ]
      }
    ]
  }
];
